import React from 'react';
import { useNavigate } from 'react-router-dom';

const ListingHeader = ({ mode = 'signup' }) => {
  const navigate = useNavigate();
  const isAddProperty = mode === 'add-property';
  return (
    <header className="listing-header" style={{ position: 'sticky', top: 0, zIndex: 1000, background: 'rgba(255, 255, 255, 0.85)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', borderBottom: '2px solid #FF7700', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)' }}>
      <div className="listing-header-inner" style={{ maxWidth: 1200, margin: '0 auto', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button type="button" className="listing-brand" onClick={() => navigate(isAddProperty ? '/dashboard' : '/login')} aria-label="TabTrips Extranet home" style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'transparent', border: 'none', cursor: 'pointer', padding: 0 }}>
          <img src="/favicon.ico" alt="TabTrips" className="listing-brand-logo" style={{ height: 32, width: 32, objectFit: 'contain' }} />
          <span className="listing-brand-text" style={{ background: 'linear-gradient(135deg, #FF7700, #FDB913)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent', fontWeight: 700, fontSize: '1.1rem' }}>TabTrips Extranet</span>
        </button>
        <button type="button" className="listing-back-btn" onClick={() => navigate(isAddProperty ? '/dashboard' : '/login')} style={{ background: 'transparent', border: '1.5px solid #FF7700', color: '#FF7700', padding: '8px 16px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
          <i className="fas fa-arrow-left" style={{ marginRight: 8 }} />
          {isAddProperty ? 'Back to Dashboard' : 'Back to Login'}
        </button>
      </div>
    </header>
  );
};

export default ListingHeader;
